export const DAY_BRIEF_CARD_BASE_CLASS = 'qmb-ui-DayBriefRenderer';
export const DAY_BRIEF_CARD_NAMESPACE = 'features.ai_chat_widget.day_brief_card';
// English defaults for hosts that supply neither `window.I18n` nor a
// `translationOverrides` entry for these keys (translate() returns the bare key).
export const DAY_BRIEF_CARD_DEFAULT_TEXT = {
    open_visit: 'Open visit',
    open_visit_for: 'Open visit %{reference}',
    directions: 'Directions',
    directions_to: 'Directions to %{name}',
    call: 'Call %{name} at %{phone}',
    access: 'Access',
    contact: 'Contact',
    site_notes: 'Site notes',
    status_completed: 'Completed',
    status_in_progress: 'In progress',
    status_scheduled: 'Scheduled',
    status_next: 'Next'
};
/** Status → translation key, for the stop header and the per-visit label. */
export const STOP_STATUS_TEXT_KEY = {
    completed: 'status_completed',
    in_progress: 'status_in_progress',
    scheduled: 'status_scheduled'
};
export const VISIT_STATUS_TEXT_KEY = Object.assign(Object.assign({}, STOP_STATUS_TEXT_KEY), { next: 'status_next' });
/** Visits whose row carries the Open visit / Directions buttons. */
export const ACTIONABLE_VISIT_STATUSES = new Set(['next', 'in_progress']);
/** A scheduled visit has no label: it is the default state of the row. */
export const UNLABELLED_VISIT_STATUSES = new Set(['scheduled']);
